import path from 'ramda/src/path'
import is from 'ramda/src/is'
import prop from 'ramda/src/prop'

import moduleDescriptions from 'root/src/shared/descriptions/modules'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

export default (state, props) => {
	const { moduleKey, fieldDescPath } = props
	const fieldDescription = path(
		[moduleIdFromKey(moduleKey), ...fieldDescPath],
		moduleDescriptions,
	)
	return is(Function, fieldDescription)
		? prop('fieldActionButton', fieldDescription(state, props))
		: prop('fieldActionButton', fieldDescription)
}
